const modalLayout = {
  modal: {
    borderRadius: 3,
    backgroundColor: 'white',
    padding: 5,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 80px)',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 1,
  },
  scrollableContent: {
    overflowY: 'auto',
    flex: 1,
    minHeight: 0,
  },
}

export default modalLayout
